
export class FormularioAuditoria {
  public IdFormulario: number;
  public NombreEstado: string;
  public FechaRegistro: string;
}
